/* global FormData */

import auth from '../auth'

const defaultOptions = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json'
  },
  mode: 'cors'
}

async function unAuthorized (endpoint, requestOptions) {
  const options = { ...defaultOptions, ...requestOptions }

  if (
    requestOptions &&
    requestOptions.body &&
    typeof requestOptions.body !== 'string' &&
    !(requestOptions.body instanceof FormData)
  ) {
    options.body = JSON.stringify(requestOptions.body)
  }

  window.$.blockUI({ message: null })

  try {
    const response = await window.fetch(
      `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
      options
    )

    if (response && response.status > 299) {
      const responseText = await response.text()
      if (response.statusText) {
        const message = responseText || `${response.status}: ${response.statusText}`
        throw new Error(message)
      }
      throw new Error(responseText)
    }

    return response
  } finally {
    window.$.unblockUI()
  }
}

async function authorized (endpoint, requestOptions) {
  const options = { ...defaultOptions, ...requestOptions }
  options.headers.Authorization = `Bearer ${auth.token}`

  return unAuthorized(endpoint, options)
}

export { unAuthorized, authorized }



// WEBPACK FOOTER //
// ./src/services/request/index.js